if (!customElements.get('swiper-text-image-icon-no-expand')) {
    customElements.define(
        'swiper-text-image-icon-no-expand',
        class SwiperTextImageIconNoExpand extends HTMLElement {
            constructor() {
                super();
                this.swiperInstance = null;
                this.swiperEl = this.querySelector('.swiper');
                this.items = this.querySelectorAll('.swiper-text-image-icon-no-expand_content-item');
            }

            connectedCallback() {
                this.initSwiper();
                // this.checkDevice();
            }

            initSwiper() {
                if (this.swiperEl) {
                    const pagination = this.querySelector('.swiper-pagination');
                    const nextBtn = this.querySelector('.swiper-button-next');
                    const prevBtn = this.querySelector('.swiper-button-prev');
                    this.swiperInstance = new Swiper(this.swiperEl, {
                        effect: 'fade',
                        speed: 600,
                        loop: true,
                        fadeEffect: {
                            crossFade: true,
                        },
                        pagination: {
                            el: pagination,
                            clickable: true,
                        },
                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        },
                    })
                }
            }

            checkDevice() {
                let el = null;
                if (window.innerWidth > 1001) {
                    el = '.swiper-text-image-icon-no-expand_content-item_content-text';
                } else {
                    el = '.swiper-text-image-icon-no-expand_content-item_content';
                }
                this.hideEl(el);
                this.clickEl(el);
            }

            hideEl(selector) {
                const elements = this.querySelectorAll(selector);
                elements.forEach((el, index) => {
                    if (index > 0) {
                        el.style.display = 'none';
                    }
                });
            }

            clickEl(selector) {
                this.items.forEach((el) => {
                    el.addEventListener('click', () => {
                        if (el.classList.contains('active')) return;
                        // 所有el移除active
                        this.items.forEach((el) => {
                            el.classList.remove('active');
                        })
                        // 当前el添加active
                        el.classList.add('active');
                        this.swiperInstance.slideTo(el.dataset.index);
                        // 使用Jquery实现动画效果
                        $(selector).slideUp();
                        const $selector = $(el).find(selector);
                        $selector.slideDown();
                    });
                })
            }

            disconnectedCallback() {
            }
        }
    );
}
